export default __webpack_public_path__ + "static/terminal_meth_lab-f23f54327ab805015a2cc8dd27d26947.png";